import styles from './GestorList.module.scss'
import { useNavigate, Link } from 'react-router-dom';
import api from '../../services/api'
import { useState, useEffect } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { BiShoppingBag, BiSupport } from "react-icons/bi";
import feedback from '../../images/feedback.svg';
import moment from 'moment/moment';
import { clearVendaSelecionada, setVendaSelecionada, getUserId } from '../../services/gestor';

// aceita dd/mm/yyyy ou yyyy-mm-dd (com ou sem hora)
const DATE_FORMATS = ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601];

function formatDate(value) {
  const m = moment(value, DATE_FORMATS, true);
  return value && m.isValid() ? m.format('DD/MM/YYYY') : '-';
}

function calcAge(value) {
  const m = moment(value, DATE_FORMATS, true);
  return value && m.isValid() ? moment().diff(m, 'years') + ' anos' : '-';
}

function GestorList() {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // volta para a lista = nenhuma venda selecionada
    clearVendaSelecionada();
    api.post('/shoppinglist', { idpessoa: getUserId() })
    .then(res => {
      if(res.data.sucesso || Array.isArray(res.data.retorno)) {
        setItems(res.data.retorno);
      }
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setLoading(false);
    })
  }, [])

  function openVenda(id) {
    setVendaSelecionada(id);
    navigate('/shopping/detail/' + id);
  }

  return (
    <>
    { loading ? <div className={styles.loading}><AiOutlineLoading3Quarters/></div> :
    <div className={styles.container}>
      <div className={styles.gestorAlert}>Você está logado como <strong>Gestor</strong>. Selecione uma venda para visualizar.</div>
      <div className={styles.headerList}>
        <h2><BiShoppingBag/> Vendas</h2>
      </div>
      <div className={styles.list}>
        {items.length === 0 ? <span className={styles.grey}>Nenhuma venda encontrada.</span> : ''}
        {items.map(item => (
          <div key={item.id} className={styles.listItem}>
            <div className={styles.cardHeader}>
              <div>
                <span className={styles.label}>Estudante</span>
                <strong className={styles.student}>{item.estudante || '-'}</strong>
              </div>
              <span className={styles.badge}>Venda nº {item.id}</span>
            </div>

            <div className={styles.info}>
              <div>
                <span className={styles.label}>Idade</span>
                <span>{calcAge(item.datanascimento)}</span>
              </div>
              <div>
                <span className={styles.label}>Início</span>
                <span>{formatDate(item.datainicio)}</span>
              </div>
              <div>
                <span className={styles.label}>País</span>
                <span>{item.pais || '-'}</span>
              </div>
              <div>
                <span className={styles.label}>Programa</span>
                <span>{item.programa || '-'}</span>
              </div>
            </div>

            <button onClick={() => openVenda(item.id)}><BiShoppingBag/> Abrir venda</button>
          </div>
        ))}
      </div>

      <div className={styles.menu}>
        <Link to="/helpdesk" className={styles.menuItem}>
          <BiSupport/>
          <h6>Precisa de ajuda? Fale com um consultor.</h6>
        </Link>
        <Link to="/sacemail" className={styles.menuItem}>
          <img src={feedback} width={30} height={30} alt=""/>
          <h6>Feedback e Sugestões</h6>
        </Link>
      </div>
    </div>
    }
    </>
  );
}

export default GestorList;
